import React from "react";
import Icon from "@ant-design/icons";

export const DeleteIcon = (props) => {
   return (
      <Icon
         component={() => (
            <svg
               width="20"
               height="21"
               viewBox="0 0 20 21"
               fill="none"
               xmlns="http://www.w3.org/2000/svg"
            >
               <g clip-path="url(#clip0_18528_7095)">
                  <g clip-path="url(#clip1_18528_7095)">
                     <path
                        d="M1.42871 5.40681H18.5716M6.42871 5.40681V4.69252C6.42871 3.74532 6.80498 2.83691 7.47475 2.16714C8.14452 1.49737 9.05294 1.12109 10.0001 1.12109C10.9473 1.12109 11.8558 1.49737 12.5255 2.16714C13.1953 2.83691 13.5716 3.74532 13.5716 4.69252V5.40681M7.85728 9.69461V15.4111M12.143 9.69461V15.4111M3.57157 5.40681H16.4287V18.264C16.4287 18.6428 16.2781 19.0062 16.0103 19.2741C15.7424 19.542 15.379 19.6925 15.0001 19.6925H5.00014C4.62125 19.6925 4.2579 19.542 3.98998 19.2741C3.72208 19.0062 3.57157 18.6428 3.57157 18.264V5.40681Z"
                        stroke="#5770CB"
                        stroke-width="1.25"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                     />
                  </g>
               </g>
               <defs>
                  <clipPath id="clip0_18528_7095">
                     <rect width="20" height="20" fill="white" transform="translate(0 0.40625)" />
                  </clipPath>
                  <clipPath id="clip1_18528_7095">
                     <rect width="20" height="20" fill="white" transform="translate(0 0.40625)" />
                  </clipPath>
               </defs>
            </svg>
         )}
         {...props}
      ></Icon>
   );
};
